import {AuthorizationService} from './authorization.service';

export function appInitializer(authenticationService: AuthorizationService) {
  return async () => {
    await authenticationService.autoLogin();
  };
}
